<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    :largura="550"
    @click:primary="gerarRelatorio"
  >
    <SysGrupoAutocomplete
      v-model="filtros.grupo"
      label="Grupos"
      outlined
      multiple
      hide-details
    />

    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      label="Segmentos"
      outlined
      multiple
      hide-details
      class="mt-4"
    />

    <SysCompradorAutocomplete
      v-model="filtros.compradores"
      label="Compradores"
      multiple
      outlined
      :qtde_visivel_selecionados="1"
      hide-details
      class="mt-4"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      :qtde-visivel-selecionados="1"
      hide-details
      class="mt-4"
    />
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import SysHistogramaPersonalizadoAutocomplete from "@/components/utils/crud/SysHistogramaPersonalizadoAutocomplete.vue";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete.vue";
import $axios from "@/api/api";

export default {
  name: "ProdutosFatorConversao",
  mixins: [Mixin],
  components: {
    SysGrupoAutocomplete,
    SysFornecedorAutocomplete,
    SysCompradorAutocomplete,
    SysSegmentoAutocomplete,
    SysHistogramaPersonalizadoAutocomplete,
    SysFilialGrupoAutocomplete
  },
  data: () => ({
    filtros: {
      grupo: [],
      fornecedores: [],
      segmentos: [],
      compradores: []
    },
  }),
  computed: {},
  methods: {
    gerarRelatorio() {
      const form = document.createElement('form');

      form.setAttribute('action', $axios.defaults.baseURL + '/relatorio_produtos_fator_conversao');
      form.setAttribute('method', 'POST');
      form.setAttribute('target', '_blank');
      form.setAttribute('style', 'display: none;');

      const filtros = { ...this.filtros };

      Object.keys(filtros).forEach(key => {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', key);
        input.setAttribute('value', filtros[key]);
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();

      form.remove();
      this.DIALOG_ATIVO = false;
    }
  }
}
</script>
